import * as Yup from "yup";

import { validationObject as baseRiskValidationObject } from "Components/Features/CheckOut/ProductTile/ProductDetails/CommonProductForms/ProductTransfer/productTransferFormValidation";
import { BoatFormState } from "Components/Features/CheckOut/ProductTile/ProductDetails/RiskProducts/Boat/boatFormTypes";
import { Company } from "Store/companies/interfaces";

export const REGEX_BOAT_REG_NUMBER = /^[0-9a-zA-ZæøåÆØÅ]+$/;
export const REGEX_BOAT_MOTOR_NUMBER =
  /^(?!^\\.|,|-|_)(?!.*[-_.,]$)[a-zA-Z0-9-_.\\/]*$/;

export const validationSchema = (
  formText: any,
  lang: string,
  insuranceCompanies: Company[],
): Yup.ObjectSchema<BoatFormState> => {
  return Yup.object({
    ...baseRiskValidationObject(insuranceCompanies),
    harbourName: Yup.string()
      .nullable()
      .max(40, formText.harbourName.validation.minMax[lang])
      .required(formText.harbourName.validation.required[lang]),
    registrationNumber: Yup.string()
      .nullable()
      .min(1, formText.registrationNumber.validation.minMax[lang])
      .max(10, formText.registrationNumber.validation.minMax[lang])
      .matches(
        REGEX_BOAT_REG_NUMBER,
        formText.registrationNumber.validation.mismatch[lang],
      )
      .required(formText.registrationNumber.validation.required[lang]),
    motorNumber: Yup.string().when("hasOutboardsMotor", {
      is: true,
      then: (schema) =>
        schema
          .nullable()
          .min(1, formText.motorNumber.validation.minMax[lang])
          .max(40, formText.motorNumber.validation.minMax[lang])
          .matches(
            REGEX_BOAT_MOTOR_NUMBER,
            formText.motorNumber.validation.mismatch[lang],
          )
          .required(formText.motorNumber.validation.required[lang]),
    }),
  }).defined();
};
